/**
 * @generated SignedSource<<a18c18503098541d1b13858b003c8384>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SongManageShare_song$data = {
  readonly id: string;
  readonly permissions: ReadonlyArray<{
    readonly canEdit: boolean;
    readonly didAccept: boolean;
    readonly email: string;
    readonly isOwner: boolean;
    readonly user: string;
    readonly " $fragmentSpreads": FragmentRefs<"SongDeleteShare_permission" | "SongUpdateShare_permission">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"ShareSongPDF_song" | "SongAddShare_song" | "SongDeleteShare_song" | "SongUpdateShare_song">;
  readonly " $fragmentType": "SongManageShare_song";
};
export type SongManageShare_song$key = {
  readonly " $data"?: SongManageShare_song$data;
  readonly " $fragmentSpreads": FragmentRefs<"SongManageShare_song">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SongManageShare_song",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SongAddShare_song"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareSongPDF_song"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SongUpdateShare_song"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SongDeleteShare_song"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SongPermission",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SongUpdateShare_permission"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SongDeleteShare_permission"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "user",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOwner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canEdit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "didAccept",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Song",
  "abstractKey": null
};

(node as any).hash = "1ff4237e226e6f57d089c79814f38c94";

export default node;
